<nav
  class="grid gap-12 grid-cols-[auto_minmax(0,1fr)_auto] items-center h-[80px] bg-white p-4 rounded-b-[20px] shadow"
>
  <a routerLink="desktop/" class="block w-[160px]">
    <img height="40px" src="assets/logos/logo-blue.svg" alt="logo" />
  </a>

  <div
    #linksContainer
    class="relative flex flex-row gap-6 text-lg whitespace-nowrap min-w-0 overflow-hidden"
  >
    <div
      #linksMeasure
      class="absolute left-0 top-0 flex flex-row gap-6 w-max invisible pointer-events-none"
      aria-hidden="true"
    >
      <span>{{ 'DESKTOP_NAV_PARKING_MAP' | localization }}</span>
      @for (menu of menus(); track menu.slug) {
      <span>{{ menu.title | localization }}</span>
      }
      <span class="inline-flex items-center gap-1">
        {{ 'DESKTOP_NAV_MORE' | localization }}
        <nz-icon nzType="down" nzTheme="outline"></nz-icon>
      </span>
    </div>

    <a
      routerLink="/desktop/main"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      class="nav-link text-center"
    >
      <span class="router-text">{{ 'DESKTOP_NAV_PARKING_MAP' | localization }}</span>
    </a>
    @for (menu of visibleMenus(); track menu.slug) {
    <a
      [routerLink]="getMenuLink(menu)"
      [class.active-link]="isMenuActive(menu)"
      (click)="onMenuClick(menu, $event)"
      class="nav-link text-center"
    >
      <span>{{ menu.title | localization }}</span>
    </a>
    } @if (overflowMenus().length) {
    <button
      type="button"
      nz-dropdown
      nzTrigger="click"
      nzPlacement="bottomRight"
      nzOverlayClassName="nav-more-dropdown"
      [nzDropdownMenu]="moreMenu"
      [class.active-link]="isOverflowActive()"
      class="nav-link inline-flex items-center gap-1 cursor-pointer rounded-md outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
    >
      {{ 'DESKTOP_NAV_MORE' | localization }}
      <nz-icon nzType="down" nzTheme="outline"></nz-icon>
    </button>
    <nz-dropdown-menu #moreMenu="nzDropdownMenu">
      <ul nz-menu>
        @for (menu of overflowMenus(); track menu.slug) {
        <li nz-menu-item [nzSelected]="isMenuActive(menu)">
          <a [routerLink]="getMenuLink(menu)" (click)="onMenuClick(menu, $event)">
            {{ menu.title | localization }}
          </a>
        </li>
        }
      </ul>
    </nz-dropdown-menu>
    }
  </div>

  <div class="flex items-center flex-shrink w-full gap-8">
    <pkp-language-selector></pkp-language-selector>
    @if (isAuthenticated$ | async) {
    <pkp-d-notifications-dropdown />
    }
    <div class="flex flex-col text-left text-sm">
      @if (isAuthenticated$ | async) {
      <div class="max-w-[150px]">
        <span class="font-medium text-base text-ellipsis overflow-hidden whitespace-nowrap block">{{
          username()
        }}</span>
        <a
          routerLink="/desktop/main/profile"
          class="relative text-sm text-[#4cb050] cursor-pointer inline-flex items-center"
        >
          {{ 'DESKTOP_NAV_GO_TO_PROFILE' | localization }}
          <nz-icon nzType="right" nzTheme="outline"></nz-icon>
          @if (feedbackUnreadCount() > 0) {
          <span
            class="absolute -right-3 top-1 h-2 w-2 rounded-full bg-[#4CB050]"
            role="img"
            [attr.aria-label]="'MOBILE_FEEDBACK_NEW_ANSWER' | localization"
            [attr.title]="'MOBILE_FEEDBACK_NEW_ANSWER' | localization"
          ></span>
          }
        </a>
      </div>
      } @else {
      <span class="font-medium">{{ 'DESKTOP_NAV_NOT_AUTHORIZED' | localization }}</span>
      <span class="text-sm">
        <a class="text-[#4cb050] cursor-pointer" (click)="goToAuthPage()">
          {{ 'NAV_AUTH_LOGIN_LINK' | localization }}
        </a>
        {{ 'NAV_AUTH_OR' | localization }}
        <a class="text-[#4cb050] cursor-pointer" (click)="goToRegisterPage()">
          {{ 'NAV_AUTH_REGISTER_LINK' | localization }}
        </a>
      </span>
      }
    </div>
  </div>
</nav>
